export const expectIntoValue = <T>(
  value: T | null | undefined,
  message?: string,
): T => {
  if (value !== undefined && value !== null) {
    return value;
  }
  throw new Error(
    `Unexpectedly found ${String(
      value,
    )} which is undefined or null. There is a serious bug in the code. Message from past:\n${
      message ?? 'No message specified 🤔'
    }`,
  );
};

export function notEmpty<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  if (value === null || value === undefined) {
    return false;
  }
  return true;
}

export type PickPartial<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

export async function blobToDataURI(blob: Blob, mimeType: string) {
  const data = await blob.arrayBuffer();
  const base64Data = Buffer.from(data).toString('base64');
  return `data:${mimeType};base64,${base64Data}`;
}

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));